/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: UrlProvider.ts
 * Project: mle-client-n
 * Committed last: 2022/7/18 @ 1122
 * ---
 * Description:
 */

import { Provider } from './Provider';

const urlFallback = require('../../config/url-fallback.json');

export class UrlProvider implements Provider {
  private _defaultDomainUrl: string;
  private _defaultApUrl: string;
  private _overrideDomainUrl?: string;
  private _overrideApUrl?: string;

  constructor() {
    this._defaultApUrl = '';
    this._defaultDomainUrl = '';

    // Init variables
    this.init();
  }

  init() {
    // @ts-ignore
    this._defaultApUrl = process.env.REACT_APP_AP_API_URL;
    // @ts-ignore
    this._defaultDomainUrl = process.env.REACT_APP_API_URL;

    if (!this._defaultDomainUrl || !this._defaultApUrl) {
      console.error(
        'ERROR: Unable to load default domain url or ap url. Fallback urls will be used');
      // Caricamento url fallback
      this._defaultApUrl = urlFallback.ap;
      this._defaultDomainUrl = urlFallback.domain;
    }

    console.info(`Successfully loaded urls: ${ this._defaultDomainUrl }`);
  }

  /**
   * Restituisce lo url da utilizzare per raggiungere il server di dominio ed inviare
   * richieste http
   */
  getDomainUrl(): string {
    return this._overrideDomainUrl || this._defaultDomainUrl;
  }

  /**
   * Imposta un valore di override dello url di dominio
   * @param value
   */
  overrideDomainUrl(value: string) {
    this._overrideDomainUrl = value;
  }

  /**
   * Restituisce lo url del server di autenticazione
   */
  getApUrl(): string {
    return this._overrideApUrl || this._defaultApUrl;
  }

  /**
   * Effettua l'override dello url per l'auth-provider
   * @param value
   */
  overrideApUrl(value: string) {
    this._overrideApUrl = value;
  }
}